'use strict';

const maximumWordLength = 18;
const truncation = '...';

function truncateWord(word) {
  const shortenedWord = word.slice(0, maximumWordLength - truncation.length);
  return shortenedWord + truncation;
}

function ensureShortWord(word) {
  return word.length > maximumWordLength ? truncateWord(word) : word;
}

module.exports = text => {
  const rawWords = text.split(/\s+/);
  const shortenedWords = rawWords.map(ensureShortWord);
  return shortenedWords.join(' ');
};
